module.exports = __webpack_public_path__ + "static/img/company-empty.9c99b425.png";